// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__iSEHu","header":"PatientBlock_header__CUieK","label":"PatientBlock_label__3x36V","option":"PatientBlock_option__RUfHD"};